import _asyncToGenerator from "F:/bio_link_pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  class: "group-box"
};
var _hoisted_2 = {
  class: "group-box-header"
};
var _hoisted_3 = {
  class: "group-box-header-title"
};
var _hoisted_4 = {
  key: 0,
  class: "group-list"
};
var _hoisted_5 = {
  class: "group-list-item-label"
};
var _hoisted_6 = ["onUpdate:modelValue", "placeholder"];
var _hoisted_7 = ["onClick"];
var _hoisted_8 = {
  class: "content"
};
var _hoisted_9 = {
  key: 1,
  class: "group-list group-list-edit"
};
var _hoisted_10 = ["placeholder"];
var _hoisted_11 = {
  class: "group-profile-footer"
};
var _hoisted_12 = ["disabled"];
import TUIChatEngine, { TUITranslateService, TUIGroupService, TUIStore, StoreName } from '@tencentcloud/chat-uikit-engine';
import { computed, reactive, watchEffect } from '../../../adapter-vue';
import { isPC } from '../../../utils/env';
import Icon from '../../common/Icon.vue';
import backIcon from '../../../assets/icon/back.svg';
import closeIcon from '../../../assets/icon/icon-close.svg';
import rightIcon from '../../../assets/icon/right-icon.svg';
import GroupIntroduction from './group-introduction/index.vue';
import { findGroupIntroConfig } from './group-introduction/config';
import Dialog from '../../common/Dialog/index.vue';
import { Toast, TOAST_TYPE } from '../../common/Toast/index';
import Server from '../server';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    var TUIGroupServer = Server.getInstance();
    var TUIConstants = TUIGroupServer.constants;
    //  'https://www.bio-cloud.com.cn:8022/icon/custom_group.png'  
    var groupInfo = reactive({
      profile: {
        groupID: '',
        name: '',
        type: TUIChatEngine.TYPES.GRP_PUBLIC,
        avatar: 'https://www.bio-cloud.com.cn:8022/icon/normal_group.png',
        introduction: '',
        notification: '',
        // joinOption: '',
        memberList: [],
        isSupportTopic: false
      },
      groupConfig: {
        title: '',
        value: '',
        key: '',
        type: '',
        placeholder: ''
      },
      isEdit: false
    });
    watchEffect(() => {
      var params = TUIGroupServer.getOnCallParams(TUIConstants.TUIGroup.SERVICE.METHOD.CREATE_GROUP);
      groupInfo.profile.memberList = params.memberList;
      groupInfo.groupConfig.title = params.title;
    });
    var groupTypeDetail = computed(() => {
      return findGroupIntroConfig(groupInfo.profile.type);
    });
    var headerTitle = computed(() => {
      var name = '添加群聊';
      if (groupInfo.isEdit) {
        name = groupInfo.groupConfig.title;
      }
      return TUITranslateService.t("TUIGroup.".concat(name));
    });
    var createInfo = computed(() => {
      var groupNameInput = {
        name: TUITranslateService.t('TUIGroup.群名称'),
        key: 'name',
        placeholder: TUITranslateService.t('TUIGroup.请输入群名称')
      };
      // const groupIDInput = {
      //   name: `${TUITranslateService.t('TUIGroup.群ID')}(${TUITranslateService.t('TUIGroup.选填')})`,
      //   key: 'groupID',
      //   placeholder: TUITranslateService.t('TUIGroup.请输入群ID')
      // }
      return groupInfo.profile.type === TUIChatEngine.TYPES.GRP_COMMUNITY ? [groupNameInput] : [groupNameInput];
    });
    var submitDisabledStatus = computed(() => {
      return groupInfo.profile.name === '' && !groupInfo.isEdit;
    });
    var selected = type => {
      if (groupInfo.profile.type !== type) {
        groupInfo.profile.type = type;
        groupInfo.profile.avatar = findGroupIntroConfig(type).icon;
        if (groupInfo.isEdit) {
          groupInfo.groupConfig.value = type;
        }
      }
    };
    var createGroup = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(function* (options) {
        try {
          options.memberList = options.memberList.map(item => {
            return {
              userID: item.userID
            };
          });
          if (options.type === TUIChatEngine.TYPES.GRP_COMMUNITY) {
            delete options.groupID;
          }
          var res = yield TUIGroupService.createGroup(options);
          var {
            type
          } = res.data.group;
          if (type === TUIChatEngine.TYPES.GRP_AVCHATROOM) {
            yield TUIGroupService.joinGroup({
              groupID: res.data.group.groupID,
              applyMessage: ''
            });
          }
          handleCompleteCreate(res.data.group);
          Toast({
            message: TUITranslateService.t('TUIGroup.群组创建成功'),
            type: TOAST_TYPE.SUCCESS
          });
        } catch (err) {
          Toast({
            message: err.message,
            type: TOAST_TYPE.ERROR
          });
        }
      });
      return function createGroup(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var submit = () => {
      var {
        profile
      } = groupInfo;
      if (groupInfo.isEdit) {
        groupInfo.profile[groupInfo.groupConfig.key] = groupInfo.groupConfig.value;
        return groupInfo.isEdit = !groupInfo.isEdit;
      } else {
        createGroup(profile);
      }
    };
    var closeCreated = () => {
      if (groupInfo.isEdit) {
        return groupInfo.isEdit = !groupInfo.isEdit;
      }
      handleCompleteCreate(null);
    };
    var edit = label => {
      groupInfo.isEdit = !groupInfo.isEdit;
      groupInfo.groupConfig.key = label;
      groupInfo.groupConfig.value = groupInfo.profile[label];
      switch (label) {
        case 'name':
          groupInfo.groupConfig.title = '设置群名称';
          groupInfo.groupConfig.placeholder = '请输入群名称';
          groupInfo.groupConfig.type = 'input';
          break;
        case 'groupID':
          groupInfo.groupConfig.title = '设置群ID';
          groupInfo.groupConfig.placeholder = '请输入群ID';
          groupInfo.groupConfig.type = 'input';
          break;
        case 'type':
          groupInfo.groupConfig.title = '选择群类型';
          groupInfo.groupConfig.type = 'select';
          break;
      }
    };
    var handleCompleteCreate = group => {
      TUIStore.update(StoreName.GRP, 'isShowCreateComponent', false);
      var callback = TUIGroupServer.getOnCallCallback(TUIConstants.TUIGroup.SERVICE.METHOD.CREATE_GROUP);
      callback && callback(group);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(Dialog, {
        show: true,
        isH5: !_unref(isPC),
        isHeaderShow: false,
        isFooterShow: false,
        background: false,
        "onUpdate:show": closeCreated
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: _normalizeClass(["group", [!_unref(isPC) ? 'group-h5' : '']])
        }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("header", _hoisted_2, [_createVNode(Icon, {
          file: _unref(isPC) ? _unref(closeIcon) : _unref(backIcon),
          class: "icon-close",
          size: "16px",
          onOnClick: closeCreated
        }, null, 8, ["file"]), _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(headerTitle)), 1)]), !_unref(groupInfo).isEdit ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(createInfo), (item, index) => {
          return _openBlock(), _createElementBlock("li", {
            key: index,
            class: "group-list-item"
          }, [_createElementVNode("label", _hoisted_5, _toDisplayString(item.name), 1), _unref(isPC) ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 0,
            "onUpdate:modelValue": $event => _unref(groupInfo).profile[item.key] = $event,
            type: "text",
            placeholder: item.placeholder
          }, null, 8, _hoisted_6)), [[_vModelText, _unref(groupInfo).profile[item.key]]]) : (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "group-h5-list-item-content",
            onClick: $event => edit(item.key)
          }, [_createElementVNode("p", _hoisted_8, _toDisplayString(_unref(groupInfo).profile[item.key]), 1), _cache[1] || (_cache[1] = _createTextVNode("avatar ")), _createVNode(Icon, {
            file: _unref(rightIcon)
          }, null, 8, ["file"])], 8, _hoisted_7))]);
        }), 128))])])) : (_openBlock(), _createElementBlock("div", _hoisted_9, [_unref(groupInfo).groupConfig.type === 'input' ? _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 0,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(groupInfo).groupConfig.value = $event),
          class: "group-name-input",
          type: "text",
          placeholder: _unref(TUITranslateService).t("TUIGroup.".concat(_unref(groupInfo).groupConfig.placeholder))
        }, null, 8, _hoisted_10)), [[_vModelText, _unref(groupInfo).groupConfig.value]]) : (_openBlock(), _createBlock(GroupIntroduction, {
          key: 1,
          class: "group-introduction-list",
          groupType: _unref(groupInfo).groupConfig.value,
          onSelectType: selected
        }, null, 8, ["groupType"]))])), _createElementVNode("footer", _hoisted_11, [_unref(isPC) && !_unref(groupInfo).isEdit ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "btn-default",
          onClick: closeCreated
        }, _toDisplayString(_unref(TUITranslateService).t('TUIGroup.取消')), 1)) : _createCommentVNode("", true), _createElementVNode("button", {
          class: "btn-submit",
          disabled: _unref(submitDisabledStatus),
          onClick: submit
        }, _toDisplayString(_unref(TUITranslateService).t('TUIGroup.确认')), 9, _hoisted_12)])])], 2)]),
        _: 1
      }, 8, ["isH5"]);
    };
  }
});